<template>
  <table aria-labelledby="table-heading-features">
		<caption id="table-heading-features">School Programs</caption>
		<thead>
			<tr>
				<th>Feature</th>
				<th>{{ s1Name }}</th>
				<th>{{ s2Name }}</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="feature in features" :key="feature.id">
				<td>{{ feature.name }}</td>
				<td>{{ hasFeature(feature.id, s1Features) ? 'yes': 'no' }}</td>
				<td>{{ hasFeature(feature.id, s2Features) ? 'yes': 'no' }}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	export default {
		props: ['s1Name', 's2Name', 's1Features', 's2Features', 'categories'],
		computed: {
			features() {
				let features = []
				this.categories.forEach(category => category.features.forEach(feature => features.push(feature)))
				return features
			}
		},
		methods: {
			hasFeature(featureID, schoolFeatures) {
				let isIncluded = false
				schoolFeatures.forEach((f) => {
					if (featureID === f.id) isIncluded = true
				})
				return isIncluded
			}
		}
	}
</script>
